// language.service.ts
import { Injectable, inject, signal } from '@angular/core';
import {Language} from 'src/app/master-data/master-data.model';
import {MasterDataService} from 'src/app/master-data/master-data-service';
import {Observable, of} from 'rxjs';
import {tap} from 'rxjs/operators';


@Injectable({ providedIn: 'root' })
export class LanguageService {
  private readonly masterdataService = inject(MasterDataService);

  private readonly _languages = signal<Language[]>([]);
  private readonly _loaded = signal(false);

  readonly languages = this._languages.asReadonly();
  readonly loaded = this._loaded.asReadonly();

  loadLanguages(): Observable<Language[]> {
    if (this._loaded()) {
      return of(this._languages());
    }

    return this.masterdataService.getLanguages().pipe(
      tap(languages => {
        this._languages.set(languages);
        this._loaded.set(true);
      })
    );
  }
}
